import { useContext, useEffect } from "react";
import { AppContext } from "../../lib/appContext";
import { getExternalURL } from "../helpers";

export const useExternalURLRedirection: UseExternalURLRedirection = (
  page,
  params,
  queryParms,
  isReady = true
) => {
  const { countryCode } = useContext(AppContext);

  useEffect(() => {
    const externalURL = getExternalURL(
      `${countryCode}.ci.${page}`,
      (params as unknown) as QueryParams
    );

    if (externalURL && isReady) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      const finalURL = queryParms ? `${externalURL}?${getQueryString(queryParms)}` : externalURL;
      window.location.href = finalURL;
    }
  }, [isReady, params]);
};

type UseExternalURLRedirection = (
  page: "quoteForm" | "newCheckout" | "newResultsPage" | "newOfferDetail",
  params: Partial<Record<"formId" | "offerId", string>>,
  queryParms?: QueryParams,
  isReady?: boolean
) => void;

type QueryParams = Record<string, string>;

function getQueryString(query: QueryParams): string {
  return Object.keys(query)
    .map(key => `${key}=${query[key]}`)
    .join("&");
}
